var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "zw zw-kamstrup-alarm-settings" }, [
    _c(
      "div",
      { staticClass: "ui basic padded segment" },
      [
        _c("div", { staticClass: "ui header" }, [
          _c("i", { staticClass: "icon bell" }),
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("pages.kamstrup_alarm_settings.title")) +
              "\n      "
          ),
          _c("div", { staticClass: "sub header" }, [
            _vm._v(_vm._s(_vm.$t("pages.kamstrup_alarm_settings.description")))
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "ui segment zw-alarm-help" }, [
          _c("h4", { staticClass: "ui header" }, [
            _vm._v(
              _vm._s(_vm.$t("pages.kamstrup_alarm_settings.how_it_works.title"))
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("pages.kamstrup_alarm_settings.how_it_works.intro"))
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ui relaxed list" }, [
            _c("div", { staticClass: "item" }, [
              _c("i", { staticClass: "chart line icon" }),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "header" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "pages.kamstrup_alarm_settings.how_it_works.percentage_title"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "pages.kamstrup_alarm_settings.how_it_works.percentage_text"
                      )
                    )
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("i", { staticClass: "tint icon" }),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "header" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "pages.kamstrup_alarm_settings.how_it_works.minimum_title"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "pages.kamstrup_alarm_settings.how_it_works.minimum_text"
                      )
                    )
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "item" }, [
              _c("i", { staticClass: "bell icon" }),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "header" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "pages.kamstrup_alarm_settings.how_it_works.maximum_title"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "pages.kamstrup_alarm_settings.how_it_works.maximum_text"
                      )
                    )
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("semantic-loading", {
          attrs: {
            active: _vm.loading,
            text: _vm.$t("globals.loaders.loading")
          }
        }),
        _vm._v(" "),
        !_vm.loading && _vm.defaults
          ? _c("div", { staticClass: "ui info message" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("pages.kamstrup_alarm_settings.default_settings", {
                      threshold: _vm.defaults.threshold_percentage,
                      min: _vm.defaults.min_absolute_volume
                    })
                  ) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.loading && !_vm.defaults
          ? _c("div", { staticClass: "ui warning message" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("pages.kamstrup_alarm_settings.no_merchant_defaults")
                  ) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.loading && !_vm.subscriptions.length
          ? _c("div", { staticClass: "ui message" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("pages.kamstrup_alarm_settings.no_subscriptions")
                  ) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.subscriptions, function(subscription) {
          return _c(
            "div",
            { key: subscription.id, staticClass: "ui segments" },
            [
              _c("div", { staticClass: "ui segment" }, [
                _c("div", { staticClass: "ui stackable grid" }, [
                  _c("div", { staticClass: "eight wide column" }, [
                    _c("h4", { staticClass: "ui header" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            subscription.product_name ||
                              _vm.$t("globals.container.subscription")
                          ) +
                          "\n              "
                      ),
                      _c("div", { staticClass: "sub header" }, [
                        _vm._v(
                          _vm._s(
                            _vm.kamstrupUserText(subscription.kamstrup_user)
                          )
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "eight wide right aligned column" },
                    [
                      _c("div", { staticClass: "ui toggle checkbox" }, [
                        _c("input", {
                          attrs: { type: "checkbox" },
                          domProps: {
                            checked: subscription.uses_custom_settings
                          },
                          on: {
                            change: function($event) {
                              return _vm.toggleCustom(
                                subscription,
                                $event.target.checked
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("pages.kamstrup_alarm_settings.use_custom")
                            )
                          )
                        ])
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ui segment" }, [
                _c(
                  "div",
                  {
                    staticClass: "ui form",
                    class: { loading: subscription.saving }
                  },
                  [
                    _c("div", { staticClass: "three fields" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pages.kamstrup_alarm_settings.threshold_percentage"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: subscription.form.threshold_percentage,
                              expression:
                                "subscription.form.threshold_percentage",
                              modifiers: { number: true }
                            }
                          ],
                          attrs: {
                            type: "number",
                            min: "1",
                            max: "100",
                            step: "1",
                            disabled: !subscription.uses_custom_settings
                          },
                          domProps: {
                            value: subscription.form.threshold_percentage
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                subscription.form,
                                "threshold_percentage",
                                _vm._n($event.target.value)
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "help-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pages.kamstrup_alarm_settings.threshold_percentage_help"
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pages.kamstrup_alarm_settings.min_absolute_volume"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: subscription.form.min_absolute_volume,
                              expression:
                                "subscription.form.min_absolute_volume",
                              modifiers: { number: true }
                            }
                          ],
                          attrs: {
                            type: "number",
                            min: "0.05",
                            max: "25",
                            step: "0.001",
                            disabled: !subscription.uses_custom_settings
                          },
                          domProps: {
                            value: subscription.form.min_absolute_volume
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                subscription.form,
                                "min_absolute_volume",
                                _vm._n($event.target.value)
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "help-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pages.kamstrup_alarm_settings.min_absolute_volume_help"
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "pages.kamstrup_alarm_settings.max_daily_volume"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.number",
                              value: subscription.form.max_daily_volume,
                              expression: "subscription.form.max_daily_volume",
                              modifiers: { number: true }
                            }
                          ],
                          attrs: {
                            type: "number",
                            min: "0.05",
                            max: "1000",
                            step: "0.001",
                            disabled: !subscription.uses_custom_settings,
                            placeholder: _vm.$t(
                              "pages.kamstrup_alarm_settings.optional"
                            )
                          },
                          domProps: {
                            value: subscription.form.max_daily_volume
                          },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                subscription.form,
                                "max_daily_volume",
                                _vm._n($event.target.value)
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ])
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "help-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "pages.kamstrup_alarm_settings.max_daily_volume_help"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "ui primary button",
                        class: { disabled: !subscription.uses_custom_settings },
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.save(subscription)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("globals.buttons.save")) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "ui button",
                        class: { disabled: !subscription.uses_custom_settings },
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.reset(subscription)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "pages.kamstrup_alarm_settings.use_default"
                              )
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ]
                )
              ])
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-32a57704", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32a57704","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/kamstrup/AlarmSettings.vue
// module id = GOAo
// module chunks = 1